import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/googleAnalytics';

/**
 * Hook to automatically track pageviews in Google Analytics
 * when the route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track the pageview
    trackPageView(location.pathname + location.search);
  }, [location]);
};
